"use client";
import React, { useState } from "react";
import { formatDate } from "../../../lib/formatDate";
import CardGrid from "../../CardGrid";
import { CommentType } from "../../constants/mockPosts";
import Comment2 from "./components/Comment2";
import SimilarPosts2 from "./components/SimilarPosts2";
import { CardVariant2 } from "./components/CardVariant2";
import BackBtn from "./components/BackBtn";
// import Button from "../../ui/Button";
import { Post, PropertyType } from "src/types";
import PostMediaCarousel from "../design1/components/PostMediaCarousel";
import { handleShareClick } from "../../constants/helperClient";
import CustomSelect from "../design1/components/ui/form/CustomSelect";
const AnnouncementPostPage2 = ({
  post,
  listings,
}: {
  post: Post;
  listings: PropertyType[];
}) => {
  return (
    <section className="py-14 ">
      <div className="wrapper ">
        <BackBtn dark />
        <div className="grid-container mt-4">
          <FirstCol mockPost={post} />
          <SecondCol properties={listings} />
        </div>
        <div className="">
          <SimilarPosts2 secondary arr={post.similar} />
        </div>
      </div>
    </section>
  );
};
export default AnnouncementPostPage2;
const FirstCol = ({ mockPost }: { mockPost: Post }) => {
  return (
    <div>
      <h1>{mockPost.title}</h1>
      <PostMediaCarousel post={mockPost} />
      <div className="text-themeColor justify-between items-center mt-5 flex">
        <span className="flex gap-2 items-center">
          <PersonIcon />{" "}
          <span className="text-secondary-main">{mockPost.author.name}</span>
        </span>

        <div className="group  xs:hidden flex gap-3">
          <StatItem
            icon={LikeIcon}
            number={mockPost.likes}
            textClassName="text-themeColor"
          />
          <StatItem icon={CommentIcon} number={mockPost.comments.length} />
          <StatItem icon={DislikeIcon} number={mockPost.dislikes} />
          <StatItem icon={EyeIcon} number={mockPost.views} />
        </div>
        <span>{formatDate(mockPost.date)}</span>
      </div>
      <div className="group mt-4  xs:flex hidden gap-3">
        <StatItem
          icon={LikeIcon}
          number={mockPost.likes}
          textClassName="text-themeColor"
        />
        <StatItem icon={CommentIcon} number={mockPost.comments.length} />
        <StatItem icon={DislikeIcon} number={mockPost.dislikes} />
        <StatItem icon={EyeIcon} number={mockPost.views} />
      </div>

      <div className="content mb-14 mt-8">
        <div
          className="flex flex-col gap-2"
          dangerouslySetInnerHTML={{ __html: mockPost.content }}
        />
      </div>

      <div className="share  mb-8">
        <h5 className="font-medium text-secondary">Share This Post:</h5>
        <div className="icons mt-4 flex items-center gap-2">
          {socialMediaLinks.map((item, index) => {
            return (
              <div
                onClick={() => handleShareClick(item.name)}
                className="grid cursor-pointer place-items-center"
                key={index}
              >
                {item.icon}
              </div>
            );
          })}
        </div>
      </div>
      <CommentsList comments={mockPost.comments} />
    </div>
  );
};

export const SecondCol = ({ properties }: { properties: PropertyType[] }) => {
  const isDemoMode = process.env.NEXT_PUBLIC_DEMO_MODE === "true";

  // Options for select
  const demoOptions = [
    { value: "rent", label: "Rent" },
    { value: "sale", label: "Sale" },
    { value: "shortlet", label: "Shortlet" },
  ];

  const [selected, setSelected] = useState<string | null>(null);

  const nonDemoOptions = [{ value: "rent", label: "Rent" }];

  return (
    <div
      style={{
        height: "700px !important",
      }}
      className="bg-white p-2 rounded-xl pt-0 child !h-[800px] shadow-md"
    >
      <div className="items-center pb-3 shadow-sm sticky top-0 z-[100] pt-6 bg-white flex justify-between">
        <h4 className="text-secondary-main font-semibold">Recent Listings</h4>

        {/* Replaced Button with Select */}
        <div className="filter rounded-md h-max p-2 border border-themeColor">
          <CustomSelect
            options={isDemoMode ? demoOptions : nonDemoOptions}
            value={selected}
            onChange={(val) => setSelected(val)}
            placeholder="Select"
            align="right"
          />
        </div>
      </div>

      <CardGrid className="divide-y divide-y-themeColor" maxColumns={1}>
        {properties.map((item, index) => {
          return (
            <div key={index} className="pt-4">
              <CardVariant2 {...item} />
            </div>
          );
        })}
      </CardGrid>
    </div>
  );
};

const PersonIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1265_182273)">
        <path
          d="M16.5 10.5C16.5 12.99 14.49 15 12 15C9.51 15 7.5 12.99 7.5 10.5C7.5 8.01 9.51 6 12 6C14.49 6 16.5 8.01 16.5 10.5Z"
          fill="var(--primary-color)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24 12C24 18.63 18.63 24 12 24C5.37 24 0 18.63 0 12C0 5.37 5.37 0 12 0C18.63 0 24 5.37 24 12ZM6 20.625C6.24 20.226 8.565 16.5 11.985 16.5C15.39 16.5 17.73 20.235 17.97 20.625C19.3648 19.6605 20.5044 18.3716 21.2909 16.8692C22.0774 15.3668 22.4872 13.6958 22.485 12C22.485 6.195 17.79 1.5 11.985 1.5C6.18 1.5 1.485 6.195 1.485 12C1.485 15.57 3.27 18.735 6 20.625Z"
          fill="var(--primary-color)"
        />
      </g>
      <defs>
        <clipPath id="clip0_1265_182273">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const LikeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 10L14.014 9.836C13.9902 9.97919 13.9978 10.1259 14.0364 10.2658C14.075 10.4057 14.1436 10.5356 14.2374 10.6464C14.3312 10.7571 14.4481 10.8461 14.5797 10.9072C14.7114 10.9683 14.8548 10.9999 15 11V10ZM4 10V9C3.73478 9 3.48043 9.10536 3.29289 9.29289C3.10536 9.48043 3 9.73478 3 10H4ZM6 21H17.36V19H6V21ZM18.56 9H15V11H18.56V9ZM15.987 10.164L16.792 5.329L14.82 5L14.014 9.836L15.987 10.164ZM14.82 3H14.606V5H14.82V3ZM11.277 4.781L8.762 8.555L10.426 9.665L12.942 5.891L11.277 4.781ZM7.93 9H4V11H7.93V9ZM3 10V18H5V10H3ZM20.302 18.588L21.502 12.588L19.542 12.196L18.342 18.196L20.302 18.588ZM8.762 8.555C8.67065 8.69192 8.54692 8.80417 8.40178 8.88179C8.25665 8.95942 8.09459 9.00002 7.93 9V11C8.42387 11 8.91009 10.878 9.3455 10.6449C9.78092 10.4119 10.1521 10.0749 10.426 9.664L8.762 8.555ZM16.792 5.329C16.8398 5.04254 16.8246 4.74911 16.7475 4.46911C16.6704 4.18911 16.5333 3.92926 16.3456 3.70762C16.1579 3.48598 15.9242 3.30787 15.6608 3.18567C15.3973 3.06347 15.1104 3.00011 14.82 3V5L16.792 5.329ZM18.56 11C18.708 10.9999 18.8541 11.0327 18.9879 11.096C19.1217 11.1592 19.2397 11.2514 19.3336 11.3658C19.4274 11.4802 19.4947 11.614 19.5306 11.7576C19.5664 11.9012 19.571 12.0509 19.542 12.196L21.502 12.588C21.589 12.1528 21.5783 11.7038 21.4708 11.2733C21.3633 10.8427 21.1617 10.4414 20.8804 10.0982C20.599 9.75501 20.2451 9.4785 19.844 9.28859C19.443 9.09869 19.0048 9.00012 18.561 9L18.56 11ZM17.36 21C18.0536 21 18.7258 20.7597 19.2622 20.32C19.7986 19.8802 20.166 19.2682 20.302 18.588L18.342 18.196C18.2966 18.4229 18.174 18.6271 17.9949 18.7737C17.8158 18.9204 17.5914 19.0003 17.36 19V21ZM14.606 3C13.9475 3.00001 13.2993 3.16257 12.7187 3.47326C12.1382 3.78395 11.6423 4.23315 11.277 4.781L12.942 5.891C13.1246 5.61698 13.372 5.39228 13.6623 5.23685C13.9526 5.08142 14.2767 5.00006 14.606 5V3ZM6 19C5.73478 19 5.48043 18.8946 5.29289 18.7071C5.10536 18.5196 5 18.2652 5 18H3C3 18.7956 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21V19Z"
        fill="var(--primary-color)"
      />
      <path d="M8 10V20" stroke="var(--primary-color)" stroke-width="2" />
    </svg>
  );
};
const CommentIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 9.8C5 8.943 5 8.361 5.038 7.911C5.073 7.473 5.138 7.248 5.218 7.092L3.436 6.184C3.189 6.669 3.09 7.186 3.044 7.748C3 8.298 3 8.976 3 9.8H5ZM5 12V9.8H3V12H5ZM3 12V17H5V12H3ZM3 17V19.914H5V17H3ZM3 19.914C3 21.205 4.562 21.852 5.475 20.939L4.061 19.525C4.13792 19.448 4.23594 19.3956 4.34265 19.3744C4.44936 19.3532 4.55998 19.364 4.6605 19.4057C4.76102 19.4473 4.84693 19.5179 4.90737 19.6083C4.9678 19.6988 5.00004 19.8052 5 19.914H3ZM5.475 20.939L8.415 18L7 16.586L4.061 19.525L5.475 20.939ZM15.2 16H8.414V18H15.2V16ZM17.908 15.782C17.752 15.862 17.528 15.927 17.089 15.962C16.639 15.999 16.057 16 15.2 16V18C16.024 18 16.701 18 17.252 17.956C17.814 17.91 18.331 17.811 18.816 17.564L17.908 15.782ZM18.782 14.908C18.5903 15.2843 18.2843 15.5903 17.908 15.782L18.816 17.564C19.5686 17.1805 20.1805 16.5686 20.564 15.816L18.782 14.908ZM19 12.2C19 13.057 19 13.639 18.962 14.089C18.927 14.527 18.862 14.752 18.782 14.908L20.564 15.816C20.811 15.331 20.91 14.814 20.956 14.252C21.001 13.702 21 13.024 21 12.2H19ZM19 9.8V12.2H21V9.8H19ZM18.782 7.092C18.862 7.248 18.927 7.472 18.962 7.911C19 8.361 19 8.943 19 9.8H21C21 8.976 21 8.299 20.956 7.748C20.91 7.186 20.811 6.669 20.564 6.184L18.782 7.092ZM17.908 6.218C18.2843 6.40974 18.5903 6.71569 18.782 7.092L20.564 6.184C20.1805 5.43139 19.5686 4.81949 18.816 4.436L17.908 6.218ZM15.2 6C16.057 6 16.639 6 17.089 6.038C17.527 6.073 17.752 6.138 17.908 6.218L18.816 4.436C18.331 4.189 17.814 4.09 17.252 4.044C16.702 4 16.024 4 15.2 4V6ZM8.8 6H15.2V4H8.8V6ZM6.092 6.218C6.248 6.138 6.472 6.073 6.911 6.038C7.361 6 7.943 6 8.8 6V4C7.976 4 7.299 4 6.748 4.044C6.186 4.09 5.669 4.189 5.184 4.436L6.092 6.218ZM5.218 7.092C5.40974 6.71569 5.71569 6.40974 6.092 6.218L5.184 4.436C4.43139 4.81949 3.81949 5.43139 3.436 6.184L5.218 7.092ZM8.414 18V16C7.88361 16.0001 7.37499 16.2109 7 16.586L8.414 18Z"
        fill="var(--primary-color)"
      />
      <path
        d="M8 9H16M8 13H13"
        stroke="var(--primary-color)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const EyeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        fill="var(--primary-color)"
      />
      <path
        d="M2 12C3.72 8.17 7.53 5.5 12 5.5C16.47 5.5 20.28 8.17 22 12C20.28 15.83 16.47 18.5 12 18.5C7.53 18.5 3.72 15.83 2 12Z"
        stroke="var(--primary-color)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const DislikeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 14L9.986 14.164C10.0098 14.0208 10.0022 13.8741 9.96357 13.7342C9.92499 13.5943 9.8564 13.4644 9.76258 13.3536C9.66875 13.2429 9.55194 13.1539 9.42025 13.0928C9.28856 13.0317 9.14516 13.0001 9 13V14ZM20 14V15C20.2652 15 20.5196 14.8946 20.7071 14.7071C20.8946 14.5196 21 14.2652 21 14H20ZM18 3H6.64V5H18V3ZM5.44 15H9V13H5.44V15ZM8.013 13.836L7.208 18.671L9.18 19L9.986 14.164L8.013 13.836ZM9.18 21H9.394V19H9.18V21ZM12.723 19.219L15.238 15.445L13.574 14.335L11.058 18.109L12.723 19.219ZM16.07 15H20V13H16.07V15ZM21 14V6H19V14H21ZM3.698 5.412L2.498 11.412L4.458 11.804L5.658 5.804L3.698 5.412ZM15.238 15.445C15.3293 15.3081 15.4531 15.1958 15.5982 15.1182C15.7434 15.0406 15.9054 15 16.07 15V13C15.5761 13 15.0899 13.122 14.6545 13.3551C14.2191 13.5881 13.8479 13.9251 13.574 14.336L15.238 15.445ZM7.208 18.671C7.16023 18.9575 7.17541 19.2509 7.2525 19.5309C7.32959 19.8109 7.46674 20.0707 7.6544 20.2924C7.84207 20.514 8.07575 20.6921 8.33921 20.8143C8.60267 20.9365 8.88958 20.9999 9.18 21V19L7.208 18.671ZM5.44 13C5.29202 13.0001 5.14588 12.9673 5.01211 12.904C4.87834 12.8408 4.76027 12.7486 4.66643 12.6342C4.57258 12.5198 4.5053 12.386 4.46943 12.2424C4.43356 12.0988 4.429 11.9491 4.458 11.804L2.498 11.412C2.41102 11.8472 2.42167 12.2962 2.52916 12.7267C2.63666 13.1573 2.83833 13.5586 3.11964 13.9018C3.40095 14.245 3.7549 14.5215 4.15597 14.7114C4.55704 14.9013 4.99524 14.9999 5.439 15L5.44 13ZM6.64 3C5.94638 2.99996 5.27417 3.24026 4.73778 3.68003C4.20139 4.11979 3.83395 4.73183 3.698 5.412L5.658 5.804C5.70336 5.57705 5.82604 5.37287 6.00511 5.22625C6.18418 5.07964 6.40856 4.99968 6.64 5V3ZM9.394 21C10.0525 21 10.7007 20.8374 11.2813 20.5267C11.8618 20.2161 12.3577 19.7668 12.723 19.219L11.058 18.109C10.8754 18.383 10.628 18.6077 10.3377 18.7631C10.0474 18.9186 9.72328 18.9999 9.394 19V21ZM18 5C18.2652 5 18.5196 5.10536 18.7071 5.29289C18.8946 5.48043 19 5.73478 19 6H21C21 5.20435 20.6839 4.44129 20.1213 3.87868C19.5587 3.31607 18.7956 3 18 3V5Z"
        fill="var(--primary-color)"
      />
      <path d="M16 14V4" stroke="var(--primary-color)" stroke-width="2" />
    </svg>
  );
};
const CommentsList = ({ comments }: { comments: CommentType[] }) => {
  return (
    <div className=" p-4">
      {/* <div className="flex text-xl pb-4 border-b border-disabled-main/50 font-semibold gap-2">
        <span>{comments.length}</span>
        Comments
      </div> */}
      {comments.length > 0 ? (
        comments.map((comment) => (
          <div
            key={comment.id}
            className=" pb-3 mb-4 border-b border-b-themeColor"
          >
            <Comment2 comment={comment} />
          </div>
        ))
      ) : (
        <p className="text-gray-500">No comments yet.</p>
      )}
    </div>
  );
};
interface StatItemProps {
  icon: React.FC; // Icon component (e.g., LikeIcon, EyeIcon)
  number: number | string; // The value to display (could be a number or formatted string)
  textClassName?: string; // Optional prop to customize text styling (e.g., for likes)
}
const StatItem: React.FC<StatItemProps> = ({
  icon: Icon,
  number,
  textClassName,
}) => {
  return (
    <div className="flex gap-1">
      <Icon />
      <span className={textClassName || ""}>{number}</span>
    </div>
  );
};

export const FacebookIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M21.998 6H18.998C17.672 6 16.4002 6.52678 15.4625 7.46447C14.5248 8.40215 13.998 9.67392 13.998 11V14H10.998V18H13.998V26H17.998V18H20.998L21.998 14H17.998V11C17.998 10.7348 18.1034 10.4804 18.2909 10.2929C18.4785 10.1054 18.7328 10 18.998 10H21.998V6Z"
        fill="white"
      />
    </svg>
  );
};
export const InstagramIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M20.166 7.66406H11.8327C9.5315 7.66406 7.66602 9.52954 7.66602 11.8307V20.1641C7.66602 22.4652 9.5315 24.3307 11.8327 24.3307H20.166C22.4672 24.3307 24.3327 22.4652 24.3327 20.1641V11.8307C24.3327 9.52954 22.4672 7.66406 20.166 7.66406Z"
        fill="white"
      />
      <path
        d="M19.3337 15.4772C19.4366 16.1707 19.3181 16.8791 18.9952 17.5014C18.6723 18.1237 18.1614 18.6284 17.5351 18.9436C16.9088 19.2588 16.1991 19.3685 15.5069 19.2571C14.8147 19.1458 14.1752 18.8189 13.6794 18.3232C13.1837 17.8274 12.8569 17.1879 12.7455 16.4957C12.6341 15.8035 12.7438 15.0938 13.059 14.4675C13.3742 13.8412 13.8789 13.3303 14.5012 13.0074C15.1236 12.6845 15.8319 12.566 16.5254 12.6689C17.2328 12.7738 17.8878 13.1034 18.3935 13.6091C18.8992 14.1148 19.2288 14.7698 19.3337 15.4772Z"
        stroke="var(--primary-color)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.584 11.4141H20.594"
        stroke="var(--primary-color)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const TwitterIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M23.5 7H8.5C8.10218 7 7.72064 7.15804 7.43934 7.43934C7.15804 7.72064 7 8.10218 7 8.5V23.5C7 23.8978 7.15804 24.2794 7.43934 24.5607C7.72064 24.842 8.10218 25 8.5 25H23.5C23.8978 25 24.2794 24.842 24.5607 24.5607C24.842 24.2794 25 23.8978 25 23.5V8.5C25 8.10218 24.842 7.72064 24.5607 7.43934C24.2794 7.15804 23.8978 7 23.5 7ZM21.0306 19.9694C21.1003 20.0391 21.1556 20.1218 21.1933 20.2128C21.231 20.3039 21.2504 20.4015 21.2504 20.5C21.2504 20.5985 21.231 20.6961 21.1933 20.7872C21.1556 20.8782 21.1003 20.9609 21.0306 21.0306C20.9609 21.1003 20.8782 21.1556 20.7872 21.1933C20.6961 21.231 20.5985 21.2504 20.5 21.2504C20.4015 21.2504 20.3039 21.231 20.2128 21.1933C20.1218 21.1556 20.0391 21.1003 19.9694 21.0306L16 17.0603L12.0306 21.0306C11.8899 21.1714 11.699 21.2504 11.5 21.2504C11.301 21.2504 11.1101 21.1714 10.9694 21.0306C10.8286 20.8899 10.7496 20.699 10.7496 20.5C10.7496 20.301 10.8286 20.1101 10.9694 19.9694L14.9397 16L10.9694 12.0306C10.8286 11.8899 10.7496 11.699 10.7496 11.5C10.7496 11.301 10.8286 11.1101 10.9694 10.9694C11.1101 10.8286 11.301 10.7496 11.5 10.7496C11.699 10.7496 11.8899 10.8286 12.0306 10.9694L16 14.9397L19.9694 10.9694C20.1101 10.8286 20.301 10.7496 20.5 10.7496C20.699 10.7496 20.8899 10.8286 21.0306 10.9694C21.1714 11.1101 21.2504 11.301 21.2504 11.5C21.2504 11.699 21.1714 11.8899 21.0306 12.0306L17.0603 16L21.0306 19.9694Z"
        fill="white"
      />
    </svg>
  );
};
export const YoutubeIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M24.7845 11.3526C24.6855 10.9571 24.4839 10.5947 24.2 10.3021C23.9161 10.0095 23.5601 9.79692 23.1678 9.68594C21.7345 9.33594 16.0011 9.33594 16.0011 9.33594C16.0011 9.33594 10.2678 9.33594 8.83446 9.71927C8.44217 9.83026 8.08611 10.0428 7.80225 10.3354C7.51839 10.6281 7.31678 10.9904 7.21779 11.3859C6.95547 12.8406 6.82716 14.3162 6.83446 15.7943C6.82511 17.2835 6.95343 18.7704 7.21779 20.2359C7.32693 20.6191 7.53305 20.9677 7.81625 21.248C8.09945 21.5283 8.45014 21.7308 8.83446 21.8359C10.2678 22.2193 16.0011 22.2193 16.0011 22.2193C16.0011 22.2193 21.7345 22.2193 23.1678 21.8359C23.5601 21.7249 23.9161 21.5124 24.2 21.2198C24.4839 20.9271 24.6855 20.5648 24.7845 20.1693C25.0448 18.7256 25.1731 17.2612 25.1678 15.7943C25.1771 14.3051 25.0488 12.8182 24.7845 11.3526Z"
        fill="white"
      />
      <path
        d="M14.125 18.5164L18.9167 15.7914L14.125 13.0664V18.5164Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
export const TikTokIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M20.0578 10.5067C19.4503 9.81291 19.1155 8.92213 19.1156 8H16.3689V19.0222C16.3481 19.6188 16.0965 20.1841 15.6669 20.5987C15.2374 21.0133 14.6636 21.2448 14.0667 21.2444C12.8044 21.2444 11.7556 20.2133 11.7556 18.9333C11.7556 17.4044 13.2311 16.2578 14.7511 16.7289V13.92C11.6844 13.5111 9 15.8933 9 18.9333C9 21.8933 11.4533 24 14.0578 24C16.8489 24 19.1156 21.7333 19.1156 18.9333V13.3422C20.2293 14.1421 21.5665 14.5712 22.9378 14.5689V11.8222C22.9378 11.8222 21.2667 11.9022 20.0578 10.5067Z"
        fill="white"
      />
    </svg>
  );
};

export const LinkedinIcon = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="32" height="32" rx="4" fill="var(--primary-color)" />
      <path
        d="M18.5 14C19.4946 14 20.4484 14.3951 21.1517 15.0983C21.8549 15.8016 22.25 16.7554 22.25 17.75V22.125H19.75V17.75C19.75 17.4185 19.6183 17.1005 19.3839 16.8661C19.1495 16.6317 18.8315 16.5 18.5 16.5C18.1685 16.5 17.8505 16.6317 17.6161 16.8661C17.3817 17.1005 17.25 17.4185 17.25 17.75V22.125H14.75V17.75C14.75 16.7554 15.1451 15.8016 15.8483 15.0983C16.5516 14.3951 17.5054 14 18.5 14Z"
        fill="white"
      />
      <path d="M12.25 14.625H9.75V22.125H12.25V14.625Z" fill="white" />
      <path
        d="M11 12.75C11.6904 12.75 12.25 12.1904 12.25 11.5C12.25 10.8096 11.6904 10.25 11 10.25C10.3096 10.25 9.75 10.8096 9.75 11.5C9.75 12.1904 10.3096 12.75 11 12.75Z"
        fill="white"
      />
    </svg>
  );
};

export const Triangle = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.49983 4.16682H17.4998C17.6517 4.1673 17.8006 4.20918 17.9304 4.28797C18.0602 4.36676 18.1661 4.47946 18.2367 4.61395C18.3072 4.74844 18.3397 4.89962 18.3307 5.05122C18.3218 5.20283 18.2716 5.34911 18.1857 5.47432L10.6857 16.3077C10.3748 16.7568 9.6265 16.7568 9.31483 16.3077L1.81483 5.47432C1.72801 5.34937 1.67711 5.20301 1.66763 5.05116C1.65816 4.8993 1.69048 4.74776 1.76109 4.61298C1.8317 4.47821 1.93789 4.36536 2.06813 4.2867C2.19837 4.20804 2.34768 4.16658 2.49983 4.16682Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};

export const socialMediaLinks = [
  { name: "Facebook", icon: <FacebookIcon />, url: "https://facebook.com" },
  { name: "Instagram", icon: <InstagramIcon />, url: "https://instagram.com" },
  { name: "Twitter", icon: <TwitterIcon />, url: "https://twitter.com" },
  { name: "Youtube", icon: <YoutubeIcon />, url: "https://youtube.com" },
  { name: "TikTok", icon: <TikTokIcon />, url: "https://tiktok.com" },
  { name: "Linkedin", icon: <LinkedinIcon />, url: "https://tiktok.com" },
];
